import ProfileSettings from "./components/profile-settings";
import { useAuth } from "@/features/auth";
// import { SpinnerPage } from '@/components/loading/spinner.page'

export default function ProfilePage() {
  // Fetch default container ID
  const { user } = useAuth();

  // if (isLoading) {
  //   return <SpinnerPage />
  // }

  // if (isError) {
  //   return (
  //     <div className="flex h-screen items-center justify-center">
  //       <div className="text-center">
  //         <p className="mb-2 text-red-500">Error fetching default profile</p>
  //         <p className="text-sm text-gray-500">{error.message}</p>
  //       </div>
  //     </div>
  //   )
  // }

  // if (!defaultProfile) {
  //   return (
  //     <div className="flex h-screen items-center justify-center">
  //       <div className="text-center">
  //         <p className="mb-2 text-red-500">No default profile found</p>
  //         <p className="text-sm text-gray-500">
  //           Please create a default container and profile to continue.
  //         </p>
  //       </div>
  //     </div>
  //   )
  // }

  return <ProfileSettings userId={user.id} />;
}
